<template>
  <div class="app-spinner">
    <half-circle-spinner
      v-if="spinner === 'half-spinner'"
      :animation-duration="800"
      :size="size"
      :color="color"
    />
    <spring-spinner
      v-else-if="spinner === 'spring-spinner'"
      :animation-duration="800"
      :size="size"
      :color="color"
    />
  </div>
</template>

<script>
import { SpringSpinner } from 'epic-spinners'
import { HalfCircleSpinner } from 'epic-spinners'

export default {
  name: 'AppSpinner',

  components: {
    SpringSpinner,
    HalfCircleSpinner,
  },
  props: {
    spinner: {
      type: String,
      default: 'half-spinner',
    },
    size: {
      type: Number,
      default: 25,
    },
    color: {
      type: String,
      default: '#9b9dd1',
    },
  },
}
</script>

<style scoped>
.app-spinner {
  /* position: absolute; */
}
</style>
